// src/components/icons/IconTrash.jsx
import React from 'react';
import { FaTrashAlt } from 'react-icons/fa';

export default function IconTrash({ size = 16, className = '', ...props }) {
  return (
    <FaTrashAlt
      size={size}
      className={`text-gray-500 hover:text-green-600 ${className}`}
      {...props}
    />
  );
}